import { useContext } from 'react';

import { UiSettingsContext } from '..';

export const useUiSettingsContext = () => useContext(UiSettingsContext);
